import type * as rrt from "@/lib/backend/reports.generated.types";

export type { ShiftTableWidgetConfig } from "@/lib/dashboardTypes";

export const MICROPLAN_EXPORT_TYPE = {
    all: "all",
    shifts: "shifts",
    orders: "orders",
};

export type OrderShift = {
    shift_time: rrt.ISimulationReportShiftTime;
    quantity_predicted: number;
    tool_setup: boolean;
};
